import { apiGet, apiPost, apiDelete, apiPatch } from './config';

export default class StageApi {
    static ModelName = 'Stage';

    static async FetchAll({ well, page, rowsPerPage }) {
        let query = `stages/well/${well.id}?sort=-stage_number`;
        if (page >= 0) {
            query += `&page=${page + 1}&limit=${rowsPerPage}`;
        }
        return apiGet(query);
    }

    static async FetchCompaniesWithoutWell() {
        return apiGet(`stages/companies?well=`);
    }

    static async FetchByPad(padId) {
        return apiGet(`stages/pad/${padId}?sort=-stage_number`);
    }

    static async FecthLastStageNumbers(wellId) {
        return apiGet(`stages/well/${wellId}/services?service_type=wireline,frac&limit=1&sort=-stage_number`);
    }

    static async FetchNewStages({ companyId, wirelineFilter, fracFilter, page = 1, rowsPerPage = 5 }) {
        let query = `stages?well=&page=${page + 1}&limit=${rowsPerPage}`;

        if (companyId) {
            query += `&company=${companyId}`;
        }

        if ((wirelineFilter || fracFilter) && wirelineFilter !== fracFilter) {
            query += `&stage_action=${wirelineFilter ? 'wireline' : 'frac'}`;
        }

        return apiGet(query);
    }

    static async CountNewStages() {
        return apiGet('stages?well=&count=1');
    }

    static async UpdateStages(payload) {
        return apiPatch(`stages`, { stages: payload });
    }

    static async DeleteStages(payload) {
        return apiPatch(`stages/delete-stages`, { stages: payload });
    }

    static async Save(stage) {
        if (!stage.id) {
            return apiPost('stages', { stage: { ...stage.attributes } });
        }

        return apiPatch(`stages/${stage.id}`, { stage: { ...stage.attributes } });
    }

    static async Start(stage) {
        if (stage.attributes.stage_action === 'wireline') {
            return StageApi.StartWireline(stage);
        }

        if (stage.attributes.stage_action === 'pumpdown') {
            return StageApi.StartPumpdown(stage);
        }

        return StageApi.StartFrac(stage);
    }

    static async Stop(stage) {
        if (stage.attributes.stage_action === 'wireline') {
            return StageApi.StopWireline(stage);
        }

        if (stage.attributes.stage_action === 'pumpdown') {
            return StageApi.StopPumpdown(stage);
        }

        return StageApi.StopFrac(stage);
    }

    static async StartWireline(stage) {
        return apiPost(`stages/${stage.id}/wireline_start`, {});
    }

    static async StartFrac(stage) {
        return apiPost(`stages/${stage.id}/frac_start`, {});
    }

    static async StartPumpdown(stage) {
        return apiPost(`stages/${stage.id}/pumpdown_start`, {});
    }

    static async StopWireline(stage) {
        return apiPost(`stages/${stage.id}/wireline_stop`, {});
    }

    static async StopFrac(stage) {
        return apiPost(`stages/${stage.id}/frac_stop`, {});
    }

    static async StopPumpdown(stage) {
        return apiPost(`stages/${stage.id}/pumpdown_stop`, {});
    }

    static async Delete(stage) {
        return apiDelete(`stages/${stage.id}`);
    }
}
